export default {
      id: "ic_betslip_horse-usage",
      viewBox: "0 0 24 17",
      url: "/" + "images/icons.3.109.2.svg#ic_betslip_horse-usage",
      toString: function () {
        return this.url;
      }
    }